import Http from '@/utils/http'

const ROUTE_ENDPOINT = '/routes/'

export const postRoute = (data) => Http.post(ROUTE_ENDPOINT, data)
export const getRoute = (id) => {
  return Http.get(`${ROUTE_ENDPOINT + id}/`)
}
export const getRoutes = () => Http.get(ROUTE_ENDPOINT)
export const deleteRoute = (id) => {
  return Http.delete(`${ROUTE_ENDPOINT + id}/`)
}
export const putRoute = (data) => {
  return Http.put(`${ROUTE_ENDPOINT + data.id}/`, data)
}
export const upsertRouteSection = (id, sections) => {
  return Http.post(
    `${ROUTE_ENDPOINT + id}/`,
    sections
  )
}

export const getAvailableSeats = (routeId, depDate) => {
  return Http.get(`${ROUTE_ENDPOINT + routeId}/available-seats/?dep_date=${depDate}`)
}



// WEBPACK FOOTER //
// ./src/services/routes.js